import { render, staticRenderFns } from "./SettingsGeneralForm.vue?vue&type=template&id=138bbd7d&scoped=true&"
import script from "./SettingsGeneralForm.vue?vue&type=script&lang=js&"
export * from "./SettingsGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGeneralForm.vue?vue&type=style&index=0&id=138bbd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138bbd7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
